import { render, staticRenderFns } from "./AIAssistantButton.vue?vue&type=template&id=4b32035c&scoped=true&"
import script from "./AIAssistantButton.vue?vue&type=script&lang=js&"
export * from "./AIAssistantButton.vue?vue&type=script&lang=js&"
import style0 from "./AIAssistantButton.vue?vue&type=style&index=0&id=4b32035c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b32035c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
